import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Product } from 'src/app/models/interface/product/product';
import { Cfs } from 'src/app/models/interface/product/cfs';
import { MatTableDataSource } from '@angular/material';
import { LocationTableObject } from 'src/app/models/products/locations/location-object.model';
import { LocationObject } from 'src/app/models/products/locations/location-tab-object-model';
import { ContactObject } from 'src/app/models/products/locations/location-contacts-table/contact-object.model';
import { CharValueObject } from 'src/app/models/products/char-value-object.model';
import { AddressObject } from 'src/app/models/products/locations/locations-address-table/address-object-model';

@Component({
  selector: 'app-product-map-locations',
  templateUrl: './product-map-locations.component.html',
  styleUrls: ['./product-map-locations.component.scss']
})
export class ProductMapLocationsComponent implements OnInit {
  @Input() item: Product;
  private _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }
  locationsTable: Array<LocationTableObject>;
  locations: Array<LocationObject>;
  dataSource: MatTableDataSource<LocationTableObject>;
  currentLocation: LocationObject;
  dataSourceId: number = 0;
  columnsToDisplay: string[] = ['role', 'numberOfContacts'];

  type: string;
  info: any;

  charValuesDataSources: Array<MatTableDataSource<CharValueObject>>;

  charValuesColumnsToDisplay: string[] = ['name', 'value'];

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit() {

    if (!this.locations) {
      this.locations = new Array<LocationObject>();
    }

    if (!this.locationsTable) {
      this.locationsTable = new Array<LocationTableObject>();
    }

    if (!this.dataSource) {
      this.dataSource = new MatTableDataSource<LocationTableObject>();
    }

    if (!this.info) {
      this.info = {};
    }

    if (!this.charValuesDataSources) {
      this.charValuesDataSources = new Array<MatTableDataSource<CharValueObject>>();
    }

    this.type = !this.params.type ? 'product' : this.params.type;
    let serviceInfo: any;

    if (this.type === 'cfs') {
      serviceInfo = this.item.cfses.find(service => service.id === +this.params.map);
    }
    if (this.type === 'rfs') {
      for (const cfs of this.item.cfses) {
        if (cfs.rfses.find(service => service.id === +this.params.map)) {
          serviceInfo = cfs.rfses.find(service => service.id === +this.params.map);
          break;
        }
      }
    }

    if (serviceInfo.locatedAt) {
      this.info = {
        specId: serviceInfo.locatedAt.specId,
        role: serviceInfo.locatedAt.role,
        addresses: serviceInfo.locatedAt.addresses
      };

      this.dataSourceId = serviceInfo.locatedAt.id;

      const newSite = new LocationTableObject(
        serviceInfo.locatedAt.id,
        serviceInfo.locatedAt.specId,
        serviceInfo.locatedAt.role,
        0);
      const contacts = new Array<ContactObject>();
      const addressesWithCorrectFormat = new Array<AddressObject>();

      for (const address of serviceInfo.locatedAt.addresses) {
        const charValues = new Array<CharValueObject>();
        for (const charValue of address.addressCharValues) {
          charValues.push(new CharValueObject(charValue.specId, charValue.value));
        }
        addressesWithCorrectFormat.push(new AddressObject(address.specId, charValues));
      }

      this.locations.push(new LocationObject(newSite, contacts, addressesWithCorrectFormat));
    }

    this.setLocations(this.locations);
  }

  private setLocations(locations: Array<LocationObject>) {
    for (const location of locations) {
      if (this.locationsTable.findIndex(locationTable => locationTable.getId() === location.getLocationsTable().getId()) === -1) {
        this.locationsTable.push(location.getLocationsTable());
      }
    }
    this.displayLocationsTable(this.locationsTable);
    if (this.locationsTable.length > 0) {
      this.changeDataSourceId(this.locationsTable[0].getId());
    }
  }

  private displayLocationsTable(locationsTable: Array<LocationTableObject>) {
    this.dataSource.data = locationsTable;
  }

  returnZero() {
    return 0;
  }

  public changeDataSourceId(dataSourceId: number) {
    this.dataSourceId = dataSourceId;
    this.currentLocation = this.locations.find(location => dataSourceId === location.getLocationsTable().getId());
    this.charValuesDataSources = new Array<MatTableDataSource<CharValueObject>>();
    for (const address of this.currentLocation.getAddresses()) {
      const charValueDataSource = new MatTableDataSource<CharValueObject>(
        address.getCharValues().filter(charValue => charValue.getName() !== 'ac_home_id_provider')
      );
      this.charValuesDataSources.push(charValueDataSource);
    }
  }

}
